import React, { useState } from 'react';
import { useTranslations } from 'next-intl';

import loadMessages from '@strongio/pretrained-dashboard/messages';
import CompactLayout from '@strongio/pretrained-dashboard/layouts/CompactLayout';
import SocialAuth from '@strongio/pretrained-dashboard/views/logistration/SocialAuth';
import Subtitle from '@strongio/pretrained-dashboard/views/logistration/register/Subtitle';
import RegisterForm from '@strongio/pretrained-dashboard/views/logistration/register/RegisterForm';

export default function RegisterView() {
  const t = useTranslations('register');
  const [emailAddress, setEmailAddress] = useState(false);

  return /*#__PURE__*/(
    React.createElement(CompactLayout, {
      title: t('create-account'),
      subtitle: /*#__PURE__*/React.createElement(Subtitle, null) },

    emailAddress ? /*#__PURE__*/
    React.createElement("div", { className: "text-center" }, /*#__PURE__*/
    React.createElement("h3", { className: "text-xl font-bold" }, t('email-sent')), /*#__PURE__*/
    React.createElement("p", { className: "mt-2 text-gray-600" }, "We have sent an activation link to",

    ' ', /*#__PURE__*/
    React.createElement("span", { className: "font-semibold text-gray-500" }, emailAddress), ". Please click on the link to active your account."), /*#__PURE__*/



    React.createElement("p", { className: "mt-4 mb-2 text-gray-500" }, "Did not receive an email?"), /*#__PURE__*/


    React.createElement("p", { className: "mb-4 text-gray-500" }, "Please check your spam folder or contact support if the problem persists.")) : /*#__PURE__*/




    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement(RegisterForm, { onSuccess: ({ email }) => setEmailAddress(email) }), /*#__PURE__*/
    React.createElement(SocialAuth, null))));




}

RegisterView.getInitialProps = async ({ locale }) => {
  const messages = await loadMessages('register', locale);

  return {
    messages,
    title: messages.register.title,
    noAuth: true };

};